import { render, staticRenderFns } from "./MttoTicketForm.vue?vue&type=template&id=670f6f29&scoped=true&"
import script from "./MttoTicketForm.vue?vue&type=script&lang=js&"
export * from "./MttoTicketForm.vue?vue&type=script&lang=js&"
import style0 from "./MttoTicketForm.vue?vue&type=style&index=0&id=670f6f29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f6f29",
  null
  
)

export default component.exports